export default __webpack_public_path__ + "static/media/evaluate-your-experiment.17d27612.pptx";